module.exports = __webpack_public_path__ + "files/b712dff9a2883f0239e4a73af110bbce.png";